import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=52cba452"
import script from "./TagItem.vue?vue&type=script&lang=ts"
export * from "./TagItem.vue?vue&type=script&lang=ts"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=52cba452&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports